import { StrictMode } from 'react';

import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { SWRConfig } from 'swr';

import { PlayerProvider } from './player/PlayerContext';
import App from './App';
import { createStore } from './modules/store';
import './styles/index.scss';
import { history } from './history';
import { AccessProvider } from './components/AccessProvider/AccessProvider';
import { PictureInPictureProvider } from './player/PictureInPictureProvider';
import { IdentityProvider } from './components/IdentityProvider/IdentityProvider';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';
import { config } from './config';
import { resolveIn } from './utils/async';
import { consentManager } from './services/privacy';

if (config.iterate.enabled) {
  resolveIn(5000)
    .then(async () => {
      const consented = await consentManager.getConsentedToAll();
      if (consented) {
        return import('./services/iterate').then((iterate) =>
          iterate.initialize()
        );
      }
    })
    .catch(() => {});
}

const store = createStore(window.ASSET, window.PAGE);

ReactDOM.render(
  <StrictMode>
    <ErrorBoundary>
      <SWRConfig value={{ revalidateOnFocus: false }}>
        <PlayerProvider>
          <Provider store={store}>
            <Router history={history}>
              <PictureInPictureProvider>
                <IdentityProvider>
                  <AccessProvider>
                    <App />
                  </AccessProvider>
                </IdentityProvider>
              </PictureInPictureProvider>
            </Router>
          </Provider>
        </PlayerProvider>
      </SWRConfig>
    </ErrorBoundary>
  </StrictMode>,
  document.getElementById('root')
);
